import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconContractStyle0 = gravityIconIndividualCss;

const GravityIconContract = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '12ade3351dd2271d3289ac676a86423a271c5d15', color: this.color, size: this.size }, h("svg", { key: '543c84606cde3d6fde50c5b693d6893cd4b166f7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '03ff026ad5da5efc1a893ee43aa05adc79b67100', d: "M16.733 10.327h-4.634a.4.4 0 0 1-.4-.4V5.293a.4.4 0 0 1 .683-.283l1.778 1.778 2.632-2.638a.5.5 0 0 1 .707 0l.353.354a.5.5 0 0 1 0 .707L15.216 7.85l1.8 1.795a.4.4 0 0 1-.283.683Zm-8.872 4.868-2.655 2.657a.5.5 0 0 1-.707 0l-.353-.354a.5.5 0 0 1 0-.707L6.8 14.134l-1.776-1.776a.4.4 0 0 1 .283-.683h4.634a.4.4 0 0 1 .4.4v4.634a.4.4 0 0 1-.68.286l-1.8-1.8Z", fill: "currentColor" }))));
    }
};
GravityIconContract.style = GravityIconContractStyle0;

export { GravityIconContract as gravity_icon_contract };

//# sourceMappingURL=gravity-icon-contract.entry.js.map